import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export default class TeamChestProgressBar extends View {
  private base: ImageScaleView;
  private fill: ImageScaleView;
  private icon: ImageScaleView;
  private label: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({ width: 327, height: 52, ...opts });

    this.base = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/frames/progress_bar_base.png',
      width: this.style.width,
      height: this.style.height,
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: {
          left: 25,
          right: 25,
        },
      },
    });

    this.fill = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/frames/progress_bar_fill.png',
      width: this.style.width,
      height: this.style.height,
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: {
          left: 25,
          right: 25,
        },
      },
    });

    this.icon = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/team_coffee_token.png',
      width: 80,
      height: 80,
      centerOnOrigin: true,
      y: this.style.height * 0.5 + 1,
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5 - 2,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 30,
      font: 'Title',
      width: this.style.width,
      height: this.style.height,
      localeText: () => '0/0',
    });

    this.setProgress({ current: 0, total: 1 });
  }

  public setProgress(args: { current: number; total: number }) {
    const current = Math.max(0, Math.min(args.current, args.total));
    const total = Math.max(0, args.total);
    const progress = current / total;
    const fillMinWidth = 54; // Just to not look weird when smaller than its slices.
    const fillRange = this.style.width - fillMinWidth;
    this.fill.updateOpts({
      width: fillMinWidth + fillRange * progress,
      visible: progress > 0,
    });
    this.label.localeText = () => `${current}/${total}`;
  }
}
